import ReactDatePicker from 'react-datepicker';
import type { DatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const datePickerExport = ReactDatePicker as unknown as React.ComponentType<DatePickerProps> & {
    default?: React.ComponentType<DatePickerProps>;
};

export const DatePicker = datePickerExport.default ?? datePickerExport;
export type { DatePickerProps };
